import { AxiosInstance } from 'axios';
import { stringify } from '../../libs/queryString';
import { CategoriesResponse, TemplatesResponse } from '../../../types/api';
import { ApiClient, ApiClientBrowseParams, ApiClientSearchParams } from './ApiClient';
import { buildBrowseRequestQuery, buildSearchRequestQuery } from './buildRequestQuery';

export class BrowserApiClient implements ApiClient {
  constructor(private axiosInstance: AxiosInstance) {}

  search(params: ApiClientSearchParams, previousUrl?: string): Promise<TemplatesResponse> {
    const query = buildSearchRequestQuery(params);
    return this.fetch(`/api/search?${stringify(query as { [key: string]: string })}`, previousUrl).then(
      (response) => response.data,
    );
  }

  browse(params: ApiClientBrowseParams, previousUrl?: string): Promise<TemplatesResponse> {
    const query = buildBrowseRequestQuery(params);
    return this.fetch(`/api/v2/templates?${stringify(query as { [key: string]: string })}`, previousUrl).then(
      (response) => response.data,
    );
  }

  fetchCategories(): Promise<CategoriesResponse> {
    return Promise.reject(new Error('Fetching categories from /api is not possible'));
  }

  private fetch(url: string, previousUrl?: string) {
    return this.axiosInstance.get(url, {
      headers: {
        'x-templates-gallery-referrer': previousUrl || '',
      },
    });
  }
}
